module.exports = __webpack_public_path__ + "img/10.fa2aaeee.webp";